// T-141 Variante B (v1.8.43, Session 39, 30.09.2026): Vorbelegung des Dialogs "Neues Angebot" aus dem Link "Als Angebot anlegen" der
// Terminanfrage-Mail (Server: Business.Buchung.AnfrageLink). Nur bei anfrage=1; Werte geprüft und begrenzt. Reine Funktion,
// getestet in anfrageVorlage.test.ts.

export interface AnfrageVorlage {
  slotId: number | null;
  datum: string; // JJJJ-MM-TT
  personen: number;
  vorname: string;
  nachname: string;
  email: string;
  telefon: string;
  notiz: string;
}

const kurz = (v: string | null, max: number) => (v ?? '').trim().slice(0, max);

/** Name in Vor- und Nachname: letztes Wort ist der Nachname, ein einzelnes Wort gilt als Nachname. */
export function teileName(name: string): { vorname: string; nachname: string } {
  const teile = name.trim().split(/\s+/).filter(Boolean);
  if (teile.length === 0) return { vorname: '', nachname: '' };
  if (teile.length === 1) return { vorname: '', nachname: teile[0] };
  return { vorname: teile.slice(0, -1).join(' '), nachname: teile[teile.length - 1] };
}

export function anfrageAusParams(p: URLSearchParams | null | undefined): AnfrageVorlage | null {
  if (!p || p.get('anfrage') !== '1') return null;
  const datum = kurz(p.get('datum'), 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(datum) || isNaN(new Date(`${datum}T12:00:00`).getTime())) return null;
  const personenRoh = parseInt(p.get('personen') || '', 10);
  const personen = isNaN(personenRoh) ? 1 : Math.min(140, Math.max(1, personenRoh));
  const slotRoh = parseInt(p.get('slot') || '', 10);
  const { vorname, nachname } = teileName(kurz(p.get('name'), 100));
  const email = kurz(p.get('mail'), 200);
  return {
    slotId: isNaN(slotRoh) || slotRoh <= 0 ? null : slotRoh,
    datum,
    personen,
    vorname,
    nachname,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : '',
    telefon: kurz(p.get('tel'), 50),
    notiz: kurz(p.get('notiz'), 500),
  };
}

/** Datum der Anfrage als lokales Datum (12 Uhr, damit keine Zeitzone den Tag verschiebt). */
export function anfrageDatum(v: AnfrageVorlage | null): Date | undefined {
  return v ? new Date(`${v.datum}T12:00:00`) : undefined;
}

/** Hinweiszeile im Dialog, z. B. "Aus Terminanfrage: 23.05.2027, 40 Personen, Max Müller (max@example.de)". */
export function anfrageHinweis(v: AnfrageVorlage | null): string {
  if (!v) return '';
  const [j, m, t] = v.datum.split('-');
  const name = [v.vorname, v.nachname].filter(Boolean).join(' ');
  return `Aus Terminanfrage: ${t}.${m}.${j}, ${v.personen} ${v.personen === 1 ? 'Person' : 'Personen'}${name ? `, ${name}` : ''}${v.email ? ` (${v.email})` : ''}`;
}

/** Anmerkungen für das Angebot: Nachricht der Anfrage mit Kennzeichnung, sonst leer. */
export function anfrageNotiz(v: AnfrageVorlage | null): string {
  return v && v.notiz ? `Aus Terminanfrage: ${v.notiz}` : '';
}
